import type { Icon, IconProps } from '@tabler/icons-react';

type AppIconProps = IconProps & {
  icon: Icon;
};

export function AppIcon({ icon: IconComponent, size = 18, stroke = 1.9, ...props }: AppIconProps) {
  return <IconComponent size={size} stroke={stroke} {...props} />;
}
